var $d1d42e963e7060c9$exports = {};
$d1d42e963e7060c9$exports = {
    "breadcrumbs": `Naviga\u{10D}n\xe9 prvky Breadcrumbs`
};


export {$d1d42e963e7060c9$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
